import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { ThisShouldNotHappenException } from '@nu-art/ts-common';
import './TS_ButtonGroup.scss';
import { ComponentSync } from '../../core/ComponentSync.js';
import { _className } from '../../utils/tools.js';
import { Button } from '../Button/Button.js';
export class TS_ButtonGroup extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        if (nextProps.controlled) { //Logic for controlled group
            state.selectedKey = nextProps.selectedKey;
        }
        else { //Logic for non-controlled group
            state.selectedKey ??= nextProps.defaultButtonKey;
        }
        state.buttons = nextProps.buttons;
        state.className = nextProps.className;
        return state;
    }
    //################################### Logic ###################################
    handleClick = async (e, buttonKey) => {
        if (this.state.actionInProgress || this.state.selectedKey === buttonKey)
            return;
        if (this.props.controlled)
            return this.handleClick_Controlled(e, buttonKey);
        return this.handleClick_NonControlled(e, buttonKey);
    };
    handleClick_Controlled = async (e, buttonKey) => {
        const result = this.props.clickCallback(buttonKey);
        //Sync operation - just return
        if (!(result instanceof Promise))
            return;
        //Async operation - Return a promise to trigger button loader
        return new Promise((resolve) => {
            //Set in progress for this component
            this.setState({ actionInProgress: true }, async () => {
                try {
                    //Await the result
                    await result;
                }
                catch (err) {
                    this.logError(err);
                }
                finally {
                    //Set not in progress, resolve the promise
                    // @ts-ignore - prevents race conditions
                    this.state.actionInProgress = false;
                    this.forceUpdate();
                    resolve();
                    // this.setState({actionInProgress: false}, () => resolve());
                }
            });
        });
    };
    handleClick_NonControlled = async (e, buttonKey) => {
        const button = this.state.buttons.find(button => button.key === buttonKey);
        if (!button)
            throw new ThisShouldNotHappenException(`Got to handle click with button key ${buttonKey}, but no button with this key exists in the state`);
        const result = button.onClick(e);
        //Sync operation - just return
        if (!(result instanceof Promise))
            return;
        //Async operation - Return a promise to trigger button loader
        return new Promise((resolve) => {
            //Set in progress for this component
            this.setState({ actionInProgress: true }, async () => {
                try {
                    //Await the result
                    await result;
                    //Set not in progress, switch the selected button key, resolve the promise
                    this.setState({ actionInProgress: false, selectedKey: buttonKey }, () => resolve());
                }
                catch (err) {
                    this.logError(e);
                    //Set not in progress, resolve the promise
                    this.setState({ actionInProgress: false }, () => resolve());
                }
            });
        });
    };
    //################################### Render ###################################
    renderButton = (button, index) => {
        const selectedButton = button.key === this.state.selectedKey;
        // when async operation is ongoing all should be disabled
        const disableButtons = button.disabled || this.state.actionInProgress;
        const buttonClassName = _className(selectedButton && 'selected', button.className);
        const separatorClassName = _className('separator', selectedButton && 'invisible');
        return _jsxs(React.Fragment, { children: [(index !== 0) && _jsx("div", { className: separatorClassName }), _jsx(Button, { variant: 'button-group-button', className: buttonClassName, id: `button-${button.key}`, onClick: e => this.handleClick(e, button.key), disabled: disableButtons, children: button.label })] }, button.key);
    };
    render() {
        const className = _className('ts-button-group', this.props.direction, this.state.className);
        return _jsx("div", { className: className, children: this.props.buttons.map((button, index) => this.renderButton(button, index)) });
    }
}
//# sourceMappingURL=TS_ButtonGroup.js.map